// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jr17bc99QYbubej8u6elew\\=\\={box-sizing:border-box;width:100%}", "",{"version":3,"sources":["webpack://./resources/sass/components/SubscriptionCancellationModal.module.scss"],"names":[],"mappings":"AAAA,4BAEI,qBAAA,CADA,UAEJ","sourcesContent":[".cancel-reason-select{\n    width: 100%;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cancel-reason-select": "jr17bc99QYbubej8u6elew=="
};
export default ___CSS_LOADER_EXPORT___;
